import { TProductoSolicitudViewModel, TwEmbalajesViewModel } from '../productos/productos.types';
import { TwSolicitudJerarquiaViewModel } from '../datosbasicos/datosbasicos.types';
import { UsuarioViewModel } from '../../../_mantenimiento/usuarios/usuarios.types';

export class SolicitudLaboratorioViewModel {
    public Id: number;
    public IdEstadoSolicitud: number;
    public IdEstadoSolicitudDescripcion = '';
    public IdTipoSolicitud: number;
    public IdTipoSolicitudDescripcion = '';
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public CodigoTipoSolicitud = '';
    public CodigoSolicitud = '';
    public CodigoTraces = '';
    public EsPredua = false;
    public EsPrevia = false;
    public EsReImportacion = false;
    public TUsuario: UsuarioViewModel;
    public TLaboratorio: TLaboratorioSolicitudViewModel;
    public TwTcMotivoMuestraLaboratorioCollection: MotivoMuestraLaboratorioViewModel[];
    public TwMotivoMuestraLaboratorioCollection: MotivoMuestraLaboratorioSolicitudViewModel[];
    public TProductoSolicitudCollection: TProductoSolicitudViewModel[];
    public TwEmbalajesCollection: TwEmbalajesViewModel[];
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    public TwEnvioMuestraLaboratorioSolicitud: TwEnvioMuestraLaboratorioSolicitudViewModel;
    public TwEnvioMuestraLaboratorioSolicitudCollection: TwEnvioMuestraLaboratorioSolicitudViewModel[];
    public TwResultadoEnvioMuestraLaboratorioSolicitud: TwResultadoEnvioMuestraLaboratorioSolicitudViewModel;
    public TwDocumentoMuestraLaboratorioSolicitudCollection: DocumentoMuestraLaboratorioSolicitudViewModel[];
}

export class EnvioMuestrasLaboratorioSolicitudInspectorViewModel {
    public TwEnvioMuestraLaboratorioSolicitud: TwEnvioMuestraLaboratorioSolicitudViewModel = new TwEnvioMuestraLaboratorioSolicitudViewModel();
    public TwMotivoMuestraLaboratorioSolicitud: TwMotivoMuestraLaboratorioSolicitudViewModel = new TwMotivoMuestraLaboratorioSolicitudViewModel();
    public TwResultadoEnvioMuestraLaboratorioSolicitud: TwResultadoEnvioMuestraLaboratorioSolicitudViewModel =
        new TwResultadoEnvioMuestraLaboratorioSolicitudViewModel();
}

export class TwEnvioMuestraLaboratorioSolicitudViewModel {
    public IdSolicitud: number;
    public IdLaboratorio: number;
    public IdUsuario: number;
    public FechaEnvio: Date;
    public ObservacionesEnvio = '';
}

export class TwMotivoMuestraLaboratorioSolicitudViewModel {
    public IdSolicitud: number;
    public MotivosCollection: MotivoMuestraLaboratorioSolicitudViewModel[];
    public ProductosCollection: TProductoSolicitudViewModel[];
    public EmbalajesCollection: TwEmbalajesViewModel[];
}

export class TwResultadoEnvioMuestraLaboratorioSolicitudViewModel {
    public IdSolicitud: number;
    public IdResultado: number;
    public IdTecnico: number | null;
    public FechaResultado: Date | null;
    public ObservacionesResultado = '';

    public TwDocumentoMuestraLaboratorioSolicitudCollection: DocumentoMuestraLaboratorioSolicitudViewModel[];
}

export class TLaboratorioSolicitudViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdUsuario: number;
    public NombreUsuario = '';
    public Observaciones = '';
    public Fecha: Date | null;
}

export class MotivoMuestraLaboratorioSolicitudViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdMotivo: number;
    public DescripcionMotivo: string;
}

export class DocumentoMuestraLaboratorioSolicitudViewModel {
    public Id: number | null;
    public IdSolicitud: number;
    public Texto = '';
    public Fecha?: Date | null;
    public NombreArchivo = '';
    public CodigoStorage = '';
    public Size: number;
    public IdUsuario: number | null;
    public MarkToDelete?: number;
    public IdDocFileSystem?: number;
}

export enum TwTcResultadoEnvioMuestraLaboratorioEnum {
    Pendiente = 1,
    Aceptada = 2,
    Rechazada = 3,
}

export class ResultadoEnvioMuestraLaboratorioViewModel {
    public Id: number;
    public Descripcion = '';
}

export class MotivoMuestraLaboratorioViewModel {
    public Id: number;
    public Descripcion = '';
}
